import React from 'react';
import { NavbarProps } from 'features/navbar/types';
import { useLayoutElements } from 'contexts/LayoutElementsContext/useLayoutElements';
import { MobileNavbarContainer } from './MobileNavbarContainer';
import { MobileTopHeader } from './MobileTopHeader';
import { MobileBottomHeader } from './MobileBottomHeader';

export const MobileNavbar: React.FC<NavbarProps> = ({
  brandLogo,
  onTabChange,
  selectedTab,
  onBrandLogoClick,
  navItemList,
}) => {
  const { setAppBarRef } = useLayoutElements();

  return (
    <MobileNavbarContainer
      topHeaderchildren={
        <MobileTopHeader onBrandLogoClick={onBrandLogoClick} brandLogo={brandLogo} />
      }
      bottomHeaderChildren={
        <MobileBottomHeader
          onTabChange={onTabChange}
          selectedTab={selectedTab}
          navItemList={navItemList}
        />
      }
      ref={setAppBarRef}
    />
  );
};
